<template>
  <div class="d-flex flex-column-fluid flex-center">
    <!--begin::Signin-->
    <div class="login-form login-signin">
      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <!-- <div role="alert" v-bind:class="{ show: errors.length }" class="alert fade alert-danger">
					<div class="alert-text" v-for="(error, i) in errors" :key="i">{{ error }}</div>
        </div>-->
        <!--begin::Title-->
        <div class="pb-13 pt-lg-0 pt-5">
          <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">宗保数字化平台</h3>
        </div>
        <!--begin::Title-->
        <!--begin::Form group-->
        <b-form-group
          id="example-input-group-1"
          label="用户名"
          label-for="example-input-1"
          label-class="font-size-h6 font-weight-bolder text-dark"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.username.$model"
            :state="validateState('username')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">请输入正确的用户名</b-form-invalid-feedback>
        </b-form-group>
        <!-- <div class="form-group">
					<label class="font-size-h6 font-weight-bolder text-dark">用户名</label>
					<input
						class="form-control form-control-solid h-auto py-7 px-6 rounded-lg"
						type="text"
						name="username"
						autocomplete="off"
					/>
        </div>-->
        <!--end::Form group-->
        <!--begin::Form group-->
        <b-form-group
          id="example-input-group-2"
          label="密码"
          label-for="example-input-2"
          label-class="font-size-h6 font-weight-bolder text-dark"
        >
          <b-form-input
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">请输入正确的密码.</b-form-invalid-feedback>
        </b-form-group>
        <!--end::Form group-->
        <!--begin::Action-->
        <div class="pb-lg-0 pb-5">
          <button
            ref="kt_login_signin_submit"
            class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3"
          >登录</button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN } from "@/core/services/store/auth";

import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        username: "",
        password: "",
      },
    };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(3),
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    removeSignin_submit() {
      this.$refs["kt_login_signin_submit"].classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;
      const signin_submit = this.$refs["kt_login_signin_submit"];
      // clear existing errors
      //this.$store.dispatch(LOGOUT);
      this.$store
        .dispatch(LOGIN, { username, password })
        .then(() => {
          this.removeSignin_submit();
          this.$router.push({ path: this.$route.query.redirect || "/" });
        })
        .catch(() => {
          this.removeSignin_submit();
          //signin_submit.add('btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3')
        });
      signin_submit.classList.add("spinner", "spinner-light", "spinner-right");
      // set spinner to submit button
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
};
</script>
